import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import format from "./format";

i18n.use(initReactI18next).init({
  fallbackLng: "it",
  lng: localStorage.getItem("language") || "it",
  resources: {
    en: {
      translations: require("./locales/en/translations.json"),
    },
    it: {
      translations: require("./locales/it/translations.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
  interpolation: {
    format,
  },
});

i18n.languages = ["en", "it"];

export default i18n;
